import type { DrinkFlows, DrinksHandledBy } from '../../flows/drinkFlows';
import {
  drinkFlowsSchema,
  drinksHandledBySchema,
} from '../../flows/drinkFlows';
import type { SchemaOf } from '../../helpers';
import { makeAllRequired, Joi } from '../../helpers';

export interface IConfig {
  drinks: DrinkFlows;
  drinksHandledBy: DrinksHandledBy;
  enableCompanionFlow: boolean;
}

export const schemaMap: SchemaOf<IConfig> = {
  drinks: drinkFlowsSchema,
  drinksHandledBy: drinksHandledBySchema,
  enableCompanionFlow: Joi.boolean(),
};

export const schemaMapDefault: SchemaOf<IConfig> = makeAllRequired(schemaMap);

export const defaultConfig: IConfig = {
  drinks: 'disabled',
  drinksHandledBy: 'invitee',
  enableCompanionFlow: false,
};
